module.exports = __webpack_public_path__ + "static/media/507.0ec346bc.png";